const PageTitle = ({ children }) => (
    <div className="border-4 border-red-600 shadow-md p-2 font-extrabold text-red-600 text-3xl w-min rounded-md flex items-center justify-center min-w-10rem whitespace-nowrap">
        {children}
    </div>
);

export default PageTitle;
